module.exports = __webpack_public_path__ + "static/media/bannerMobile@1x.5bb21a65.jpg";